export default "__VITE_ASSET__67dd1fb5__"